/** Sometimes you need to know how many items are there in field array component. */
export const getFieldArrayLength = (values) => values[Object.keys(values)[0]?.length];
